import { PrimitiveAtom, atom } from 'jotai';

export interface IBroadcastChannel {
  onmessage: ((this: BroadcastChannel, ev: MessageEvent<any>) => any) | null;
  postMessage: (message: any) => void;
}

type BroadcastChannelConstructorType = new (...args: any[]) => IBroadcastChannel;

// react native doesn't support BroadcastChannel, so make it optional
let bc: BroadcastChannelConstructorType | undefined;
try {
  bc = BroadcastChannel;
} catch (err) {}

export function atomWithBroadcast<Value>(key: string, initialValue: Value) {
  const baseAtom = atom(initialValue);
  const listeners = new Set<(event: MessageEvent<any>) => void>();

  const channel = bc
    ? new bc(key)
    : ({
        onmessage: () => {},
        postMessage: () => {},
      } as IBroadcastChannel);

  if (channel) {
    channel.onmessage = event => {
      listeners.forEach(l => l(event));
    };
  }

  const broadcastAtom = atom<Value, { isEvent: boolean; value: Value }[], any>(
    get => get(baseAtom),
    (get, set, update) => {
      set(baseAtom, update.value);

      if (!update.isEvent) {
        channel.postMessage(get(baseAtom));
      }
    },
  );

  broadcastAtom.onMount = setAtom => {
    const listener = (event: MessageEvent<any>) => {
      setAtom({ isEvent: true, value: event.data });
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };
  const returnedAtom = atom<Value, Value[], any>(
    get => get(broadcastAtom),
    (get, set, update) => {
      set(broadcastAtom, { isEvent: false, value: update });
    },
  );
  return returnedAtom as PrimitiveAtom<Value>;
}
